import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-power-bi-modal',
  templateUrl: './power-bi-modal.component.html',
  styleUrls: ['./power-bi-modal.component.scss']
})
export class PowerBiModalComponent implements OnInit {

  @Input() showModal: boolean;

  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

}
